module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-01-990582f7c731e2dd6e508739d91504fb.jpg";